// 退房
import { OccType } from '@/config/constant';
import { CheckOutAction } from '@/redux/actions/reservation/constant';
import { RoomGuestItem } from './base.d';

// 房间信息
export interface RentRecordInfo {
  indexId: string; // 唯一标识
  resvNo: string; // 主单号
  recNo: string; // 子单号
  extensionFlag: boolean; // 是否续住
  roomTypeName: string; // 房型名称
  roomId: string; // 房间ID
  roomNo: string; // 房间号
  occType: OccType; // 入住类型
  roomCardCount: number; // 房卡数量
  checkinTime: number; // 入住时间
  expectedDepartureTime: number; // 预离时间
  occDuration: number; // 入住时长
  overtime: number; // 超时时长
  overtimePrice: string; // 实收超时房费
  overtimePriceReceivable: string; // 应收超时房费
}

// 冲调信息
export interface AdjustRecordInfo extends RentRecordInfo {
  indexId: string; // 唯一标识
  adjustPrice: string; // 冲调金额
  adjustReason: string; // 冲调原因
  adjustRemarks: string; // 冲调备注
}

export interface MainState {
  roomGuestList: RoomGuestItem[]; // 宾客列表
  rentRoomList: RentRecordInfo[]; // 房间列表
  overtimePriceAdjustList: AdjustRecordInfo[]; // 超时房费冲调列表
  peripheralRoomInventoryList: any[]; // 外设房间库存列表
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
  cardEnabled: boolean; // 房卡管理是否启用
}

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const initialState: ReducerState = {
  isInit: false,
  isLoading: true,
  cardEnabled: false,
  rentRoomList: [],
  roomGuestList: [],
  overtimePriceAdjustList: [],
  peripheralRoomInventoryList: [],
};

const reducerMap = {
  [CheckOutAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [CheckOutAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [CheckOutAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [CheckOutAction.setCardStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, cardEnabled: payload };
  }),
  [CheckOutAction.setRentRoomList]: <ActionHandler<RentRecordInfo[]>>((state, { payload }) => {
    return { ...state, rentRoomList: payload };
  }),
  [CheckOutAction.setPeripheralReturnList]: <ActionHandler<RentRecordInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, peripheralRoomInventoryList: payload };
  }),
  [CheckOutAction.setOvertimePriceAdjustList]: <ActionHandler<RentRecordInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, overtimePriceAdjustList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'checkOut';
